import {
  AdCampaign,
  AdsAuditLog,
  AdsCampaignStatus,
  BillingItem,
  Creative,
  Placement,
  Report,
} from "./types";

const iso = (date: string) => `${date}T00:00:00.000Z`;


export const mockCampaigns: AdCampaign[] = [
  {
    id: "cmp_1",
    name: "Summer Campaign",
    advertiserId: "",
    advertiserName: "TechGear Inc",
    placement: "Home Banner",
    pricingModel: "CPC",
    budget: 10000,
    spend: 8200,
    startAt: iso("2026-02-27"),
    endAt: iso("2026-03-06"),
    status: AdsCampaignStatus.ACTIVE,
  },
  {
    id: "cmp_2",
    name: "User Acquisition Campaign",
    advertiserId: "",
    advertiserName: "TechGear Inc",
    placement: "Shop Banner",
    pricingModel: "CPM",
    budget: 5000,
    spend: 1000,
    startAt: iso("2026-02-27"),
    endAt: iso("2026-03-06"),
    status: AdsCampaignStatus.ACTIVE,
  },
  {
    id: "cmp_3",
    name: "Growth Campaign",
    advertiserId: "",
    advertiserName: "TechGear Inc",
    placement: "Home Banner",
    pricingModel: "Flat",
    budget: 10000,
    spend: 8200,
    startAt: iso("2026-02-20"),
    endAt: iso("2026-02-27"),
    status: AdsCampaignStatus.EXPIRED,
  },
  {
    id: "cmp_4",
    name: "Clearance Sale",
    advertiserId: "",
    advertiserName: "TechGear Inc",
    placement: "Home Banner",
    pricingModel: "Flat",
    budget: 5000,
    spend: 1000,
    startAt: iso("2026-02-27"),
    endAt: iso("2026-03-06"),
    status: AdsCampaignStatus.ACTIVE,
  },
  {
    id: "cmp_5",
    name: "User Acquisition Campaign",
    advertiserId: "",
    advertiserName: "TechGear Inc",
    placement: "Pop up",
    pricingModel: "CPM",
    budget: 5000,
    spend: 1000,
    startAt: iso("2026-02-27"),
    endAt: iso("2026-03-06"),
    status: AdsCampaignStatus.DRAFT,
  },
  {
    id: "cmp_6",
    name: "Clearance Sale",
    advertiserId: "",
    advertiserName: "TechGear Inc",
    placement: "Shop Banner",
    pricingModel: "CPM",
    budget: 10000,
    spend: 8200,
    startAt: iso("2026-02-27"),
    endAt: iso("2026-03-06"),
    status: AdsCampaignStatus.ACTIVE,
  },
  {
    id: "cmp_7",
    name: "User Acquisition Campaign",
    advertiserId: "",
    advertiserName: "TechGear Inc",
    placement: "Tournament Banner",
    pricingModel: "Flat",
    budget: 5000,
    spend: 1000,
    startAt: iso("2026-02-27"),
    endAt: iso("2026-03-06"),
    status: AdsCampaignStatus.COMPLETED,
  },
  {
    id: "cmp_8",
    name: "Growth Campaign",
    advertiserId: "",
    advertiserName: "TechGear Inc",
    placement: "Pop up",
    pricingModel: "CPC",
    budget: 5000,
    spend: 1000,
    startAt: iso("2026-02-20"),
    endAt: iso("2026-02-27"),
    status: AdsCampaignStatus.EXPIRED,
  },
  {
    id: "cmp_9",
    name: "Growth Campaign",
    advertiserId: "",
    advertiserName: "TechGear Inc",
    placement: "Pop up",
    pricingModel: "CPM",
    budget: 10000,
    spend: 8200,
    startAt: iso("2026-02-27"),
    endAt: iso("2026-03-06"),
    status: AdsCampaignStatus.COMPLETED,
  },
  {
    id: "cmp_10",
    name: "Brand Awareness Drive",
    advertiserId: "",
    advertiserName: "TechGear Inc",
    placement: "Home Banner",
    pricingModel: "CPM",
    budget: 15000,
    spend: 4500,
    startAt: iso("2026-03-01"),
    endAt: iso("2026-03-31"),
    status: AdsCampaignStatus.ACTIVE,
  },
];

export const mockCreatives: Creative[] = [
  {
    id: "cr-001",
    campaignName: "Summer Campaign",
    placement: "Home Banner",
    status: AdsCampaignStatus.ACTIVE,
    createdAt: iso("2026-01-15"),
    previewUrl: "",
  },
  {
    id: "cr-002",
    campaignName: "User Acquisition Campaign",
    placement: "Shop Banner",
    status: AdsCampaignStatus.ACTIVE,
    createdAt: iso("2026-01-15"),
    previewUrl: "",
  },
  {
    id: "cr-003",
    campaignName: "Growth Campaign",
    placement: "Home Banner",
    status: AdsCampaignStatus.PAUSED,
    createdAt: iso("2026-01-15"),
    previewUrl: "",
  },
  {
    id: "cr-004",
    campaignName: "Clearance Sale",
    placement: "Home Banner",
    status: AdsCampaignStatus.ACTIVE,
    createdAt: iso("2026-01-15"),
    previewUrl: "",
  },
  {
    id: "cr-005",
    campaignName: "User Acquisition Campaign",
    placement: "Pop up",
    status: AdsCampaignStatus.PAUSED,
    createdAt: iso("2026-01-15"),
    previewUrl: "",
  },
  {
    id: "cr-006",
    campaignName: "Clearance Sale",
    placement: "Shop Banner",
    status: AdsCampaignStatus.ACTIVE,
    createdAt: iso("2026-01-15"),
    previewUrl: "",
  },
  {
    id: "cr-007",
    campaignName: "User Acquisition Campaign",
    placement: "Tournament Banner",
    status: AdsCampaignStatus.COMPLETED,
    createdAt: iso("2026-01-15"),
    previewUrl: "",
  },
  {
    id: "cr-008",
    campaignName: "Growth Campaign",
    placement: "Pop up",
    status: AdsCampaignStatus.PAUSED,
    createdAt: iso("2026-01-15"),
    previewUrl: "",
  },
  {
    id: "cr-009",
    campaignName: "Growth Campaign",
    placement: "Pop up",
    status: AdsCampaignStatus.COMPLETED,
    createdAt: iso("2026-01-15"),
    previewUrl: "",
  },
];

export const mockPlacements: Placement[] = [
  {
    id: "pla_1",
    name: "Home Banner",
    description: "Main banner on home page",
    enabled: true,
    frequencyCap: 5,
    frequencyCapPerSession: false,
    maxAdvertisers: 3,
  },
  {
    id: "pla_2",
    name: "Tournament Banner",
    description: "Main banner on home page",
    enabled: false,
    frequencyCap: 5,
    frequencyCapPerSession: false,
    maxAdvertisers: 3,
  },
  {
    id: "pla_3",
    name: "Shop Banner",
    description: "Banner in shop section",
    enabled: true,
    frequencyCap: 7,
    frequencyCapPerSession: true,
    maxAdvertisers: 5,
  },
  {
    id: "pla_4",
    name: "Popup",
    description: "Full-screen popup ad",
    enabled: true,
    frequencyCap: 1,
    frequencyCapPerSession: false,
    maxAdvertisers: 3,
  },
];

export const mockReports: Report[] = [
  {
    id: "rep_1",
    title: "Campaign Performance - Mar 01 to Mar 15",
    reportType: "PERFORMANCE",
    status: AdsCampaignStatus.ACTIVE,
    periodStartAt: iso("2026-03-01"),
    periodEndAt: iso("2026-03-15"),
  },
  {
    id: "rep_2",
    title: "Revenue Impact - Current Month",
    reportType: "REVENUE",
    status: AdsCampaignStatus.ACTIVE,
    periodStartAt: iso("2026-03-01"),
    periodEndAt: iso("2026-03-25"),
  },
];

export const mockBilling: BillingItem[] = [
  { id: "bill_1",  advertiserName: "TechGear Inc", campaignName: "Summer Campaign",           eventType: "CLICK",      referenceId: "REF-82341",  amount: 45200, timestamp: "2026-02-25T14:32:00.000Z" },
  { id: "bill_2",  advertiserName: "TechGear Inc", campaignName: "User Acquisition Campaign", eventType: "FLAT",       referenceId: "REF-82342",  amount: 45200, timestamp: "2026-02-25T14:32:00.000Z" },
  { id: "bill_3",  advertiserName: "TechGear Inc", campaignName: "Growth Campaign",           eventType: "CLICK",      referenceId: "REF-82343",  amount: 45200, timestamp: "2026-02-25T14:32:00.000Z" },
  { id: "bill_4",  advertiserName: "TechGear Inc", campaignName: "Clearance Sale",            eventType: "FLAT",       referenceId: "REF-82344",  amount: 45200, timestamp: "2026-02-25T14:32:00.000Z" },
  { id: "bill_5",  advertiserName: "TechGear Inc", campaignName: "User Acquisition Campaign", eventType: "CLICK",      referenceId: "REF-82345",  amount: 45200, timestamp: "2026-02-25T14:32:00.000Z" },
  { id: "bill_6",  advertiserName: "TechGear Inc", campaignName: "Clearance Sale",            eventType: "CLICK",      referenceId: "REF-82346",  amount: 45200, timestamp: "2026-02-25T14:32:00.000Z" },
  { id: "bill_7",  advertiserName: "TechGear Inc", campaignName: "Growth Campaign",           eventType: "IMPRESSION", referenceId: "REF-82347",  amount: 45200, timestamp: "2026-02-25T14:32:00.000Z" },
  { id: "bill_8",  advertiserName: "TechGear Inc", campaignName: "Summer Campaign",           eventType: "CPM",        referenceId: "REF-82348",  amount: 45200, timestamp: "2026-02-25T14:32:00.000Z" },
  { id: "bill_9",  advertiserName: "TechGear Inc", campaignName: "User Acquisition Campaign", eventType: "CLICK",      referenceId: "REF-82349",  amount: 45200, timestamp: "2026-02-25T14:32:00.000Z" },
  { id: "bill_10", advertiserName: "TechGear Inc", campaignName: "Summer Campaign",           eventType: "FLAT",       referenceId: "REF-823410", amount: 45200, timestamp: "2026-02-25T14:32:00.000Z" },
];


export const mockAdsAuditLogs: AdsAuditLog[] = [];

